import type { FinancialTransactionFormValues } from "gsintegrations";
import { axiosClient } from "../api/axiosClient";

export type FinancialTransactionWithTerreiroId =
  FinancialTransactionFormValues & {
    terreiroId?: string;
    mediumId?: string;
    settlementStatus?: "PROJECTED" | "CONSOLIDATED";
  };

// For edit, require id
export type FinancialTransactionWithIdAndTerreiroId =
  FinancialTransactionWithTerreiroId & { id: string };
export const incomingRepository = {
  /**
   * Create an incoming (entrada) transaction.
   * POST /incoming
   */
  createIncoming: async (payload: FinancialTransactionWithTerreiroId) => {
    const { data } = await axiosClient.post("/incoming", payload, {
      withCredentials: true,
    });
    return data;
  },

  /**
   * Edit an incoming (entrada) transaction.
   * PUT /incoming/:id
   */
  editIncoming: async (payload: FinancialTransactionWithIdAndTerreiroId) => {
    const { id, ...rest } = payload;
    const { data } = await axiosClient.put(`/incoming/${id}`, rest, {
      withCredentials: true,
    });
    return data;
  },

  /**
   * Get a single incoming (entrada) transaction by id.
   * GET /incoming/:id
   */
  getIncomingById: async (id: string) => {
    const { data } = await axiosClient.get(`/incoming/${id}`, {
      withCredentials: true,
    });
    return data;
  },

  updateSettlementStatus: async (
    id: string,
    settlementStatus: "PROJECTED" | "CONSOLIDATED",
  ) => {
    const { data } = await axiosClient.patch(
      `/incoming/${id}/settlement-status`,
      { settlementStatus },
      { withCredentials: true },
    );
    return data;
  },
};
